import { Icon } from "antd";
import "./index.less";
import middleware from "../../middleware";
class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false
    };
  }
  showError() {
    this.setState({
      showError: true
    });
    setTimeout(() => {
      this.setState({
        showError: false
      });
    }, 2000);
  }
  render() {
    const { showError } = this.state;
    const {
      tipPosition = "top",
      error = "",
      children,
      className = "",
      style = {}
    } = this.props;
    return (
      <div
        className={`wea-error inline-block ${
          error && showError ? "has-error" : ""
        } ${className}`}
        style={style}
      >
        {children}
        {error && showError && (
          <span
            className={`error-tip ${
              tipPosition == "bottom" ? "tip-bottom" : ""
            }`}
          >
            <Icon type="exclamation-circle" />
            <span className="tip-msg">{error}</span>
          </span>
        )}
      </div>
    );
  }
}

const Com = middleware(main, "WeaError");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-error/index.js